<template>
  <div class="rb-product-info rb-wrap">
    <div class="rb-content">
      <div>
        <div class="rb-breadcrumb-wrap">
          <div class="rb-breadcrumb">
            <a href="/">Home</a>
            <a href="/collections/engagement-rings">Engagement</a>
            <span>{{ product.title }}</span>
          </div>
          <div>
            <button
              :class="['rb-whishlist-btn', { 'rb-active': isWhishlisted }]"
              aria-label="Add to Favorites"
              id="btn-whishlist"
              @click.prevent="notifyWhishlist"
            >
              <icon-heart />
              <icon-heart-full />
            </button>
          </div>
        </div>
        <div class="rb-product-info-wrap">
          <div>
            <h1 class="rb-product-title">{{ product.title }}</h1>
          </div>
          <div>
            <a href="#" @click.prevent="notifyDropAHint">Drop a hint</a>
          </div>
        </div>

        <div class="rb-product-description-wrap">
          <div
            class="rb-product-description"
            v-html="product.description"
          ></div>
          <div class="rb-reviews" @click.prevent="notifyReviews"></div>
        </div>

        <div class="rb-variants-selector">
          <step-choices
            :data="stepDataShape"
            :selected-options="selectedOptions"
            :carousel="false"
            :enable-title="true"
            :title-display="stepDataShape.label"
            :product="data.product"
            :mappings="data.mappings"
            :availability="availability"
            :enable-notice-warn="false"
          />
        </div>

        <div
          class="rb-variants-selector"
          v-if="
            selectedOptions &&
            selectedOptions.length > 0 &&
            selectedOptions.find(
              (selectedOption) => selectedOption.step.id === 'shape'
            )
          "
        >
          <step-choices
            :data="stepDataMetal"
            :selected-options="selectedOptions"
            :carousel="false"
            :enable-title="true"
            :title-display="stepDataMetal.label"
            :product="data.product"
            :mappings="data.mappings"
            :availability="availability"
            :enable-notice-warn="false"
            :help-id="stepDataMetal.popupId"
          />
        </div>

        <div class="rb-pricing">
          <div class="rb-price" v-show="renderInitDiamondPrice">
            {{ renderDiamondPrice }}
          </div>
          <pricing
            v-show="!renderInitDiamondPrice"
            message-prev="Total Ring Price from "
            message-prev-complete="Total Ring Price "
            message-post="- Setting Price"
            :combine-price="data.combinePrice"
          />

          <stock-status-description 
            :use-dash="false" 
            :shipping-text="data.shippingText"
          />
        </div>

        <button
          class="btn v2 rb-book-appointment-btn"
          @click.prevent="notifyAcuity(data.bookAppointmentUrl)"
        >
          Book a Virtual or In-person Appointment
        </button>

        <a
          class="btn v2 rb-contact-btn"
          :href="data.customerCare.contactLink"
          v-if="data.customerCare && data.customerCare.enableContact"
        >
          {{ data.customerCare.contactTitle }}
        </a>

        <button
          class="btn v1 rb-add-to-cart"
          @click.prevent="startBuilder"
          id="btn-start-builder"
        >
          Select Your Diamond
        </button>

        <!-- <affirm :installments="4" /> -->
        <affirm-updater />

        <div class="rb-social-wrap">
          <div class="rb-shipping-notice">
            {{ product.metafields_custom.lead_time_information || "" }}
          </div>
        </div>
        <div class="rb-page-nav">
          <div>
            <a
              href="#"
              @click.prevent="notifyProductDetails"
              id="btn-product-details"
              >Product Details</a
            >
          </div>
          <div>
            <a href="#" @click.prevent="startBuilder" id="btn-explore-diamonds">
              Explore Diamonds
            </a>
          </div>
          <div>
            <a :href="data.ringSizerUrl" target="_blank" id="btn-ring-sizer"
              >Free Ring Sizer</a
            >
          </div>
          <div>
            <a
              href="#"
              @click.prevent="notifyShare"
              class="rb-btn-share"
              id="btn-info-share"
            >
              Share
            </a>
          </div>
        </div>

        <share-nav v-if="showShareOptions" :data="data" :product="product" />
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Product information for PDP when it's not fullscreen
 *
 * @props
 * complete: Boolean
 * availability: Array
 *
 * @implements
 * ChildMixin
 * CommMixin
 * TrackMixin
 *
 * @emits
 * rb-start-builder
 * rb-open-diamond-explorer
 * rb-whishlist
 * rb-product-details
 * rb-drop-a-hint
 * rb-yotpo-reviews
 *
 * @listens
 * rb-whishlist-prev
 *
 */
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import StepChoices from "@/components/StepChoices";
import Pricing from "@/components/Pricing";
import AffirmUpdater from "@/components/AffirmUpdater";
import ShareNav from "@/components/ShareNav";
import IconHeart from "@/components/icons/IconHeart";
import IconHeartFull from "./icons/IconHeartFull";
import ChildMixin from "@/mixins/ChildMixin";
import StockStatusDescription from "@/components/StockStatusDescription.vue";
export default {
  components: {
    Pricing,
    // Affirm,
    AffirmUpdater,
    StepChoices,
    StockStatusDescription,
    ShareNav,
    IconHeart,
    IconHeartFull,
  },
  mixins: [ChildMixin, CommMixin, TrackMixin],
  props: {
    complete: {
      type: Boolean,
      default: false,
    },
    availability: {
      type: Array,
      default: () => [],
    },
    renderInitDiamondPrice: {
      type: Boolean,
      default: false,
    },
    renderDiamondPrice: {
      type: String,
    },
  },
  data: function () {
    return {
      isWhishlisted: false,
      showShareOptions: false,
    };
  },
  computed: {
    stepDataShape: function () {
      return this.data.steps.find((step) => step.id === "shape");
    },
    stepDataMetal: function () {
      return this.data.steps.find((step) => step.id === "metal");
    },
    product: function () {
      return this.data.product;
    },
  },
  mounted: function () {
    this.subscribe("rb-whishlist-prev", this.onWhishlistPrev);
  },
  methods: {
    startBuilder: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-start-builder");
    },
    openDiamondExplorer: function () {
      this.broadcast("rb-open-diamond-explorer");
    },
    notifyShare: function (event) {
      // this.broadcast("rb-open-popup", { id: "rb-popup-share" });
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.showShareOptions = !this.showShareOptions;
    },
    notifyWhishlist: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-whishlist");
      this.onWhishlistPrev();
    },
    onWhishlistPrev: function () {
      this.isWhishlisted = !this.isWhishlisted;
    },
    notifyProductDetails: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-product-details");
    },
    notifyDropAHint: function () {
      this.broadcast("rb-drop-a-hint");
    },
    notifyReviews: function (event) {
      this.broadcast("rb-yotpo-reviews");
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      // this.trackEvent('rb_click')
    },
    notifyAcuity: function (url) {
      this.broadcast("rb-acuity", url);
    },
  },
};
</script>
